<div class="header d-flex justify-content-between align-items-center w-100">
  <div class="d-flex gap-1 align-items-center">
    <svg-icon src="assets/icons/building.svg"></svg-icon>
    <div class="text-gray">{{ establishment?.name }}</div>
  </div>
  <div class="d-flex align-items-center gap-2">
    <div class="mr-px-20 position-relative">
      <div class="badge" *ngIf="notifNotReaded">
        {{ notifNotReaded > 99 ? "+99" : notifNotReaded }}
      </div>
      <svg-icon
        (click)="notifNotReaded = 0"
        [matMenuTriggerFor]="notif"
        class="notification"
        src="assets/icons/notif.svg"
      ></svg-icon>
      <div>
        <mat-menu #notif="matMenu" class="notification-container">
          <app-notification-panel
            [notifications]="notification"
            (itemClick)="notifClicked($event)"
          ></app-notification-panel>
        </mat-menu>
      </div>
    </div>
    <div>
      <div
        [matMenuTriggerFor]="userMenu"
        class="profile-menu d-flex align-items-center gap-2"
      >
        <!--        <img [src]="displayImg(this.user?.image)" class="user-img" alt="user" />-->
        <div>
          <div class="name">{{ user?.name }}</div>
          <div class="email">{{ user?.email }}</div>
        </div>
        <svg-icon src="assets/icons/chevron-down.svg"></svg-icon>
      </div>
      <mat-menu #userMenu="matMenu">
        <!--        <button mat-menu-item class="" [routerLink]="['/dashboard', 'profile']">-->
        <!--          <svg-icon src="assets/icons/profile.svg"></svg-icon>-->
        <!--          Mon profil-->
        <!--        </button>-->

        <button mat-menu-item (click)="disconnect()">
          <svg-icon src="assets/icons/disconnect.svg"></svg-icon>
          Se déconnecter
        </button>
      </mat-menu>
    </div>
  </div>
</div>
